'use client';

import type { UserType } from '@/lib/types/user.types';

/**
 * يحصل على نوع المستخدم من journey tester
 * يمكن استخدامه في الصفحات المشتركة لتحديد نوع المستخدم الحالي
 *
 * @returns نوع المستخدم الحالي أو null إذا لم يكن في وضع الاختبار
 */
export function getJourneyUserType(): UserType | null {
  if (typeof window === 'undefined') return null;

  // أولاً: التحقق من query parameter
  const urlParams = new URLSearchParams(window.location.search);
  const queryUserType = urlParams.get('__userType') as UserType | null;
  if (queryUserType && ['client', 'supplier', 'admin'].includes(queryUserType)) {
    return queryUserType;
  }

  // ثانياً: التحقق من localStorage
  const storedUserType = localStorage.getItem('__journey_user_type__') as UserType | null;
  if (storedUserType && ['client', 'supplier', 'admin'].includes(storedUserType)) {
    return storedUserType;
  }

  return null;
}

/**
 * يتحقق من أن المستخدم الحالي في وضع اختبار الرحلة
 */
export function isJourneyTestingMode(): boolean {
  return getJourneyUserType() !== null;
}

/**
 * يحصل على نوع المستخدم المخزن في localStorage فقط (بدون query parameter)
 * مفيد للـ layouts التي تحتاج للتحقق من journey type
 */
export function getStoredJourneyUserType(): 'client' | 'supplier' | null {
  if (typeof window === 'undefined') return null;

  const storedUserType = localStorage.getItem('__journey_user_type__') as UserType | null;
  if (storedUserType && (storedUserType === 'client' || storedUserType === 'supplier')) {
    return storedUserType;
  }

  return null;
}

/**
 * يحصل على نوع المستخدم مع fallback إلى نوع افتراضي
 *
 * @param defaultType النوع الافتراضي إذا لم يكن في وضع الاختبار
 * @returns نوع المستخدم
 */
export function getJourneyUserTypeWithFallback(
  defaultType: UserType | null = null
): UserType | null {
  return getJourneyUserType() || defaultType;
}
